module.exports = __webpack_public_path__ + "static/media/rating-students.47a9bd60.svg";